import jsPDF from "jspdf";
import html2canvas from "html2canvas";

export const downloadCertificatePDF = async (id, filename) => {
  const element = document.getElementById(id);
  const canvas = await html2canvas(element, { scale: 2 });

  const img = canvas.toDataURL("image/png");
  const pdf = new jsPDF("p", "mm", "a4");

  const w = 210;
  const h = (canvas.height * w) / canvas.width;

  pdf.addImage(img, "PNG", 0, 0, w, h);
  pdf.save(filename);
};
